export type TCardPosition = {
  slot: TCardLayoutSlot;
  order: TCardSlotPosition;
};

export type TCard = {
  id: CardId;
  position: TCardPosition;
};

export enum TCardLayoutSlot {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  RIGHT = 'RIGHT',
}

export enum TCardSlotPosition {
  FIRST = 0,
  SECOND = 1,
  FILL = -1, // FOR CARDS THAT FILL THE ENTIRE AREA
}

export enum CardId {
  PROJECTS = 'projects',
  DEVICES = 'devices',
  PIPELINES = 'pipelines',
  ACTIVITY = 'activity',
  ANNOUNCEMENTS = 'announcements',
  GROUPS = 'groups',
}

export type TGridTemplate = {
  areas: string;
  columns: string;
  rows: string;
};

export type TGridContainerProps = {
  $template: string;
  $hasGap?: boolean;
};

export type TSlotProps = {
  $area: keyof typeof TCardLayoutSlot;
  $slotsFilled: number;
};

export type TCardContainerProps = {
  $flexOrder?: number;
  $isDragging?: boolean;
};
